import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const HVRenegadesLink = () => (
  <Link
    target="_blank"
    href="https://am.ticketmaster.com/hvrenegades/"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    Hudson Valley Renegades
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your Hudson Valley Renegades account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <HVRenegadesLink /> Account Manager in
        early 2025. Reach out to Live Fan Support for any questions
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Hudson Valley Renegades Flex Program work?",
    description: (
      <>
        The Hudson Valley Renegades Flex Program allows fans to select any seat
        to select games hosted by the Renegades. Simply log into your Hudson
        Valley Renegades{" "}
        <Link
          target="_blank"
          href="https://am.ticketmaster.com/hvrenegades/"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          Account Manager
        </Link>{" "}
        and select games.
      </>
    ),
  },
  {
    title: "How do I redeem my VIP experience?",
    description:
      "To redeem your VIP experience, please check in with Guest Services in the 1st Base Breezeway when you arrive!",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Hudson Valley Renegades{" "}
        <Link
          target="_blank"
          href="https://am.ticketmaster.com/hvrenegades/"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          Account Manager
        </Link>
        .
      </>
    ),
  },
];
